import { gql } from "@apollo/client";

export const NEWS = gql`
  query news($first: Int!, $skip: Int!, $culture: String!, $status: Status!) {
    news(orderBy: {publishedUtc: DESC},first: $first, skip: $skip, where: {localization: {culture: $culture}}, status: $status) {
      displayText
      summary
      createdUtc
      publishedUtc
      figure {
          paths
      }
      localization {
        localizationSet
      }
    }
  }
`

export const NEWS_DETAILS = gql`
  query newsDetails($culture: String!, $localizationSet: String!) {
    news(where: {localization: {culture: $culture, localizationSet: $localizationSet}}) {
      contentItemId
      __typename
      displayText
      summary
      createdUtc
      publishedUtc
      figure {
        paths(first: 1)
      }
      content {
        contentItems {
          contentItemId
          contentType
        }
      }
    }
  }
`